<template>
  <div class="analytics-card">
    <OurCard size="sm">
      <template #header-left>
        <OurHeader size="xxs" weight="medium" :text="title" />
      </template>

      <template #header-right>
        <OurSvgIcon :src="icon" :color="iconColor" pill size="sm" />
      </template>

      <div class="analytics-card-content">
        <div class="analytics-card-value">
          <AnimatedNumber :value="value" />
        </div>
        <div class="analytics-card-description">{{ contentText }}</div>
      </div>

      <template v-if="footer" #footer-left>
        <div class="analytics-card-footer-item">
          <div class="analytics-card-footer-label">{{ footer.left.label }}</div>
          <div class="analytics-card-footer-value analytics-card-footer-value--blue">
            {{ footer.left.value }}
          </div>
        </div>
      </template>

      <template v-if="footer" #footer-right>
        <div class="analytics-card-footer-item analytics-card-footer-item--right">
          <div class="analytics-card-footer-label">{{ footer.right.label }}</div>
          <div class="analytics-card-footer-value analytics-card-footer-value--orange">
            {{ footer.right.value }}
          </div>
        </div>
      </template>
    </OurCard>
  </div>
</template>

<script>
import AnimatedNumber from "@/ui/AnimatedNumber.vue";

export default {
  name: "AnalyticsCard",

  components: {
    AnimatedNumber,
  },

  props: {
    title: {
      type: String,
      default: "",
    },

    icon: {
      type: String,
      default: "",
    },

    iconColor: {
      type: String,
      default: "blue",
    },

    value: {
      type: [String, Number],
      default: "",
    },

    contentText: {
      type: String,
      default: "",
    },

    footer: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="postcss" scoped>
.analytics-card {
  &-content {
    @apply flex flex-col gap-1;
  }

  &-value {
    @apply text-2xl font-bold leading-tight text-gray-900;
  }

  &-description {
    @apply text-sm text-gray-500;
  }

  &-footer-item {
    @apply flex flex-col gap-1;

    &--right {
      @apply items-end text-right;
    }
  }

  &-footer-label {
    @apply text-xs text-gray-500;
  }

  &-footer-value {
    @apply text-sm font-medium;

    &--blue {
      @apply text-blue-500;
    }

    &--orange {
      @apply text-orange-500;
    }
  }
}

.analytics-card:deep(.our-card-content) {
  @apply !mt-0;
}

.analytics-card:deep(.our-card) {
  @apply h-full;
}
</style>
